import React from "react"
import { Box, Tooltip, MenuItem, FormControl, ListItemText, Checkbox, makeStyles, TextField } from "@material-ui/core"
import { KeyboardArrowDown } from "@material-ui/icons"

const useStyles = makeStyles((theme) => ({
	boxWrapper: {
		maxWidth: 185,
		minWidth: 185,
		minHeight: 48,
		maxHeight: 48,
		backgroundColor: theme.palette.common.white,
		border: `solid 1px ${theme.palette.grey.D400}`,
		borderRadius: "5px",
	},
	font: {
		fontWeight: 400,
	},
	select: {
		"& .MuiSvgIcon-root": {
			color: theme.palette.text.primary,
		},
		"& .MuiSelect-root": {
			...theme.typography.body1,
		},
		"& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline": {
			border: "transparent",
		},
		"& .MuiSelect-icon.Mui-disabled": {
			opacity: "0.5",
		},
	},
}))

//basic settings
const MenuProps = {
	PaperProps: {
		style: {
			minWidth: 225,
			width: 225,
			maxHeight: 287,
			top: 325,
			textTransform: "capitalize",
		},
	},
	anchorOrigin: {
		vertical: "bottom",
		horizontal: "left",
	},
	variant: "menu",
	getContentAnchorEl: null,
}

const HasAttachment = ({ handleAttachmentChange, selected = [], setSelected = () => {}, disableFilters, attachmentOptions }) => {
	const classes = useStyles()

	const handleChange = (event) => {
		const value = event.target.value
		if (value.includes(-1)) {
			//is cleared click
			setSelected([])
			handleAttachmentChange([])
		} else {
			setSelected(value)
			handleAttachmentChange(value)
		}
	}

	const getAttachmentNames = (ids) => {
		let attachmentNames = []
		if (ids?.length > 0) {
			for (let i = 0; i < ids?.length; i++) {
				if (attachmentOptions?.length > 0) {
					const found = attachmentOptions?.filter((option) => option?.id === ids[i])
					found?.[0]?.name && attachmentNames?.push(found?.[0]?.name)
				}
			}
		}
		return attachmentNames
	}

	const getAttachmentName = (id) => {
		const attaachment = attachmentOptions?.find((option) => option.id === id)
		return attaachment?.name || null
	}

	return (
		<Box className={classes.boxWrapper} m={1}>
			<FormControl fullWidth size="small">
				<Tooltip placement="top" arrow title={getAttachmentNames(selected)?.join(", ")}>
					<TextField
						variant="outlined"
						value={selected}
						onChange={handleChange}
						select
						label="Email attachment"
						id="attachment-multiple-checkbox-label"
						SelectProps={{
							labelId: "attachment-multiple-checkbox-label",
							MenuProps: MenuProps,
							IconComponent: KeyboardArrowDown,
							renderValue: (selected) => {
								let selectedTags = getAttachmentNames(selected)
								return selectedTags?.join(", ")
							},
							multiple: true,
							onOpen: () => {
								setTimeout(() => {
									selected?.length > 0 &&
										document.querySelector(`[data-name=${getAttachmentName(`${selected?.[0]}`)}]`)?.scrollIntoView()
								}, 1)
							},
						}}
						InputLabelProps={{ style: { fontWeight: 400 } }}
						size="small"
						className={classes.select}
						disabled={disableFilters}
					>
						{attachmentOptions?.map((option) => (
							<MenuItem
								style={{
									paddingLeft: option?.id !== -1 ? 1 : 15,
								}}
								key={option?.id}
								value={option?.id}
								data-name={option?.name}
							>
								{option?.id !== -1 && <Checkbox size="small" checked={selected?.indexOf(option?.id) > -1} />}
								<Tooltip placement="top" arrow title={option?.name}>
									<ListItemText
										primary={option?.name}
										style={{ fontWeight: 400 }}
										primaryTypographyProps={{ style: { fontWeight: 400 } }}
									/>
								</Tooltip>
							</MenuItem>
						))}
					</TextField>
				</Tooltip>
			</FormControl>
		</Box>
	)
}

export default HasAttachment
